class FlyoutMenu extends HTMLElement {
  constructor() {
    super();

    this.topLinks = this.querySelectorAll('.top-links > *')
    this.subSectionTitle = this.querySelector('.sub-section-title')
    this.subSections = this.querySelectorAll('.sub-sections > *')
    this.images = this.querySelectorAll('.images > *')

    this.setup()
    this.setSelected(0)
  }

  setup() {
    this.topLinks.forEach((el, i) => {
      el.addEventListener('mouseover', this.setSelected.bind(this, i))
    })
  }

  setSelected(selected) {
    this.currentItem = selected

    this.subSectionTitle.classList.remove('tw-hidden')
    this.setActiveElement({
      elements: Array.from(this.topLinks).map(el => el.querySelector('[role="button"]')),
      add: ['tw-border-b-3'],
    })
    this.showActiveElement({ elements: this.subSections })
    this.showActiveElement({ elements: this.images })
  }

  showActiveElement({ elements }) {
    this.setActiveElement({ elements, remove: ['tw-hidden'] })
  }

  setActiveElement({ elements, add = [], remove = [] }) {
    elements.forEach((el, i) => {
      if (i == this.currentItem) {
        el.classList.remove(...remove)
        el.classList.add(...add)
      } else {
        el.classList.remove(...add)
        el.classList.add(...remove)
      }
    })
  }
}

customElements.define('flyout-menu', FlyoutMenu);
